import Bookmarks from "../components/Bookmarks/Bookmarks";

const BookmarksPage = (): JSX.Element => {
  return <Bookmarks />;
};

export default BookmarksPage;
